import type { PrioridadeTriagem } from '../../didatico/ocupantes'
import { preencherAchados } from './preencherAchados'
import type { FichaVitimaAtendimento } from './tipos'
import { VITIMAS_TREINAMENTO } from './vitimasTreinamento'

export const VITIMA_SLIDE_49_V1_MOTORISTA: FichaVitimaAtendimento = {
  id: 'slide_49_v1_motorista',
  titulo: 'Slide 49–50: V1 Motorista Crítico (Choque e Painel)',
  perfil: {
    papel: 'Motorista',
    mecanismo: 'Colisão frontal severa contra barreira rígida com colapso de habitáculo',
    condicaoDescrita: 'Choque descompensado/hipovolêmico, confusão mental e retenção mecânica pelo painel deformado',
    ator: 'Fala frases curtas e entrecortadas ("tô sem ar... me tira daqui..."), confuso, sonolento se não estimulado',
    aparencia: 'Sudoreico, pálido, cianose labial leve, expressão de sofrimento agudo',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Pálido, sudoreico, geme com dor abdominal e torácica', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Responder com frases de 2 a 3 palavras, voz fraca, sonolência progressiva', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante externo visível em grandes vasos', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea pérvia, porém fala apenas frases curtas; colar cervical indicado de imediato', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '28 irpm, respiração rápida, superficial e entrecortada', leitura: '28 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrios vesiculares presentes bilateralmente, sem estertores patológicos imediatos', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Expansão simétrica e reduzida pela taquipneia superficial', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '124 bpm, pulso radial filiforme, difícil de palpar', leitura: '124 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: 'Tempo de enchimento capilar lentificado (> 3 segundos)', leitura: '> 3 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '85/55 mmHg (hipotensão acentuada / choque)', leitura: '85/55 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Pele fria, pálida e sudoreica (pegajosa)', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 10 (O3/V3/M4), sonolento e confuso', leitura: 'Glasgow 10', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Responde a estímulo Verbal/Dor', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Pupilas isocóricas e fotorreagentes', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Hipotermia em evolução (35,4 °C); retenção mecânica na região dos joelhos e pedaleira', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '91% em ar ambiente', leitura: '91%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '35,4 °C', leitura: '35,4 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '8/10 difusa no tronco e membros inferiores', leitura: '8/10', estado: 'observado' },
    sample_sintomas: { valor: '"Muita dor no peito e na barriga... frio..."', estado: 'observado' },
    sample_evento_trauma: { valor: 'Colisão frontal súbita a cerca de 60 km/h', estado: 'observado' },
    sec_torax_abdomen_pelve: { valor: 'Contusão na parede torácica anterior por cinto; abdômen tenso e doloroso à palpação', estado: 'observado', regiao: 'torax' },
    sec_membros_dorso: { valor: 'Pernas presas sob o painel e pedais; pulsos pediosos presentes porém fracos', estado: 'observado', regiao: 'membroInferiorEsquerdo' },
  }),
  estagios: [
    { id: 'tardio', rotulo: 'Tardio', achados: {
      c_pressao_arterial: { valor: '75/40 mmHg (choque refratário)', leitura: '75/40 mmHg', estado: 'observado' },
      d_escala_glasgow: { valor: 'Glasgow 8 (O2/V2/M4) — queda neurológica rápida', leitura: 'Glasgow 8', estado: 'observado' },
      sinais_spo2: { valor: '88% em ar ambiente', leitura: '88%', estado: 'observado' },
    } },
  ],
  cinematica: {
    tipoColisao: 'frontal',
    alvoImpacto: 'muro',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 60,
    regioesPreviveis: ['cabeca', 'torax', 'abdomen', 'membroInferiorEsquerdo', 'membroInferiorDireito'],
  },
  intervencoesCitadas: ['Colar cervical', 'Oxigenoterapia em alto fluxo', 'Manta térmica', 'Extração rápida'],
  pendencias: ['Etiologia do choque (sangramento retroperitoneal / torácico)', 'Verificar liberação dos pedais antes da tração'],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'Sinais inequívocos de choque descompensado (PA 85/55, perfusão > 3s, Glasgow 10). Imediato.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_rapida', 'rota_vertical_teto'],
    notasDebriefing: [
      'Não perder tempo com cortes cosméticos: o paciente está chocando.',
      'Rebater ou retirar o teto e retirar em ângulo reto ou rota rápida assistida.',
    ],
  },
}

export const VITIMA_SLIDE_51_V1_MOTORISTA: FichaVitimaAtendimento = {
  id: 'slide_51_v1_motorista',
  titulo: 'Slide 51–52: V1 Motorista Estável (Pernas Presas)',
  perfil: {
    papel: 'Motorista',
    mecanismo: 'Impacto frontal assimétrico; painel e pedais recuados sobre as pernas',
    condicaoDescrita: 'Estável fisiologicamente, mas com encarceramento físico tipo II nos membros inferiores',
    ator: 'Consciente, orientado, colaborativo: "Estou bem, mas meus pés estão travados embaixo do painel!"',
    aparencia: 'Corado, hidratado, consciente, gesticulando com os braços livres',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Lúcido, conversando, incapaz de recuar as pernas', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Orientar o resgatista sobre onde a pedaleira está pinçando o pé esquerdo', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Escoriações em pernas com pequeno sangramento venoso sem jato', estado: 'observado', regiao: 'membroInferiorEsquerdo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea totalmente pérvia, fala sem esforço', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '18 irpm, eupneico', leitura: '18 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrios vesiculares universalmente audíveis e límpidos', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '84 bpm, cheio e regular', leitura: '84 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: '< 2 segundos (boa perfusão sistêmica)', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '130/80 mmHg', leitura: '130/80 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Normotérmica, corada, sem sudorese excessiva', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6), lúcido e orientado no tempo e espaço', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    sinais_spo2: { valor: '98% em ar ambiente', leitura: '98%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_escala_dor: { valor: '6/10 no tornozelo e pé esquerdo', leitura: '6/10', estado: 'observado' },
    sec_membros_dorso: { valor: 'Pé esquerdo entalado entre a pedaleira de freio e o túnel central; pulso pedioso presente', estado: 'observado', regiao: 'membroInferiorEsquerdo' },
  }),
  cinematica: {
    tipoColisao: 'frontal',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 40,
    regioesPreviveis: ['pelve', 'membroInferiorEsquerdo', 'membroInferiorDireito'],
  },
  intervencoesCitadas: ['Alinhamento de coluna com colar cervical', 'Afastamento de painel ou corte de pedais'],
  pendencias: ['Risco de compressão vascular prolongada se o desencarceramento demorar'],
  gabaritoInstrutor: {
    triagemSugerida: 'amarelo',
    justificativaTriagem: 'Estável hemodinâmica e neurologicamente, mas retido por ferragens com lesão potencial.',
    prioridadeExtracao: 'urgente',
    rotasRecomendadas: ['rota_lateral_porta', 'rota_longitudinal_traseira'],
    notasDebriefing: [
      'Embora estável, sua permanência no assento pode bloquear a saída do passageiro grave.',
      'A equipe precisa coordenar a liberação dos pedais sem gerar giro na coluna.',
    ],
  },
}

export const VITIMA_SLIDE_51_V2_PASSAGEIRO: FichaVitimaAtendimento = {
  id: 'slide_51_v2_passageiro',
  titulo: 'Slide 51–52: V2 Passageiro Instável (Acesso Obstruído)',
  perfil: {
    papel: 'Passageiro Dianteiro',
    mecanismo: 'Impacto lateral/diagonal direito com intrusão de porta',
    condicaoDescrita: 'Trauma torácico fechado com insuficiência respiratória progressiva e rebaixamento do sensório',
    ator: 'Gemência ruidosa, respira com grande esforço, responde com palavras desconexas',
    aparencia: 'Palidez, sudorese, expansão torácica assimétrica',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Gemendo, dispneico, porta do lado direito colapsada', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Emitir gemidos de dor ao respirar fundo e não conseguir articular frases completas', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante exteriorizado', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Vias aéreas pérvias com respiração estertorosa por secreção/esforço', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '32 irpm, taquipneia severa e uso de musculatura acessória', leitura: '32 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular acentuadamente diminuído no hemitórax direito', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Assimetria ventilatória; dor intensa à palpação de arcos costais direitos', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '130 bpm, filiforme', leitura: '130 bpm', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_perfusao_periferica: { valor: '> 3 segundos', leitura: '> 3 s', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pressao_arterial: { valor: '95/60 mmHg', leitura: '95/60 mmHg', estado: 'observado', regiao: 'membroSuperiorDireito' },
    d_escala_glasgow: { valor: 'Glasgow 11 (O3/V3/M5), confuso e agitado por hipóxia', leitura: 'Glasgow 11', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Verbal / Dor', estado: 'observado', regiao: 'cabeca' },
    sinais_spo2: { valor: '87% em ar ambiente', leitura: '87%', estado: 'observado', regiao: 'membroSuperiorDireito' },
    sinais_escala_dor: { valor: '9/10 no hemitórax direito', leitura: '9/10', estado: 'observado' },
    sec_torax_abdomen_pelve: { valor: 'Crepitação óssea em 4º a 6º arcos costais direitos; sem enfisema subcutâneo exuberante', estado: 'observado', regiao: 'torax' },
  }),
  cinematica: {
    tipoColisao: 'lateral',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'passageiro',
    retencao: 'comCinto',
    velocidadeImpacto: 45,
    regioesPreviveis: ['torax', 'pelve', 'membroSuperiorDireito'],
  },
  intervencoesCitadas: ['Oxigênio sob máscara com reservatório a 15 L/min', 'Colar cervical', 'Afastamento da porta direita'],
  pendencias: ['Possível pneumotórax hipertensivo em evolução'],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'Hipóxia severa (SpO2 87%), taquipneia (32 irpm) e taquicardia filiforme. Prioridade Imediata.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_lateral_porta', 'rota_lateral_b', 'rota_vertical_teto'],
    notasDebriefing: [
      'Dilema tático: V2 é vermelho e V1 é amarelo, mas a porta direita de V2 está bloqueada.',
      'A equipe deve decidir entre arrombar a porta direita rapidamente ou extrair pelo teto.',
    ],
  },
}

export const VITIMA_SLIDE_53_V1_MOTORISTA: FichaVitimaAtendimento = {
  id: 'slide_53_v1_motorista',
  titulo: 'Slide 53–54: V1 Motorista Estável (Retirada Alinhada 0°)',
  perfil: {
    papel: 'Motorista',
    mecanismo: 'Colisão frontal com desaceleração moderada; habitáculo preservado',
    condicaoDescrita: 'Estável com queixa de cervicalgia e dorsalgia; sem aprisionamento esquelético',
    ator: 'Consciente, orientado, calmo: "Bati a frente, meu pescoço tá doendo um pouco e a porta tá emperrada"',
    aparencia: 'Corado, lúcido, segurando a cabeça encostada no encosto',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Consciente, orientado, sem sangramento visível', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Relatar dor no pescoço que piora ao virar para os lados; solicitar colar', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Ausente', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Pérvia, conversa normalmente sem estridor', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '16 irpm, respiração ritmada', leitura: '16 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrios vesiculares preservados e simétricos', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '76 bpm, pulso cheio e regular', leitura: '76 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: '< 2 segundos', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '120/80 mmHg', leitura: '120/80 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Pele quente, seca e corada', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6)', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    sinais_spo2: { valor: '99% em ar ambiente', leitura: '99%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '36,5 °C', leitura: '36,5 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '4/10 em região cervical posterior', leitura: '4/10', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Dor à palpação na linha média da coluna cervical baixa; sem deformidades ósseas visíveis', estado: 'observado', regiao: 'cabeca' },
    sec_membros_dorso: { valor: 'Sensibilidade e motricidade preservadas nos quatro membros (PMS 100%)', estado: 'observado', regiao: 'membroInferiorEsquerdo' },
  }),
  cinematica: {
    tipoColisao: 'frontal',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 30,
    regioesPreviveis: ['torax', 'abdomen'],
  },
  intervencoesCitadas: ['Estabilização cervical manual imediata', 'Colar cervical de tamanho apropriado', 'Retirada em 0° com prancha longa'],
  pendencias: ['Evitar qualquer flexão ou rotação axial durante o corte e a extração'],
  gabaritoInstrutor: {
    triagemSugerida: 'verde',
    justificativaTriagem: 'Sinais vitais normais e Glasgow 15. Vítima estável; requer cuidado pela cervicalgia.',
    prioridadeExtracao: 'estavel',
    rotasRecomendadas: ['rota_longitudinal_traseira', 'rota_vertical_teto'],
    notasDebriefing: [
      'Com vítimas estáveis, o foco didático é a técnica perfeita e a eliminação do ângulo de giro.',
      'A retirada longitudinal traseira ou remoção total do teto oferece alinhamento biomecânico ideal.',
    ],
  },
}

export const VITIMA_SLIDE_53_V2_PASSAGEIRO: FichaVitimaAtendimento = {
  id: 'slide_53_v2_passageiro',
  titulo: 'Slide 53–54: V2 Passageiro Estável (Rotas Paralelas)',
  perfil: {
    papel: 'Passageiro Dianteiro',
    mecanismo: 'Desaceleração frontal com cinto de 3 pontos afivelado',
    condicaoDescrita: 'Estável, lúcido, dor discreta no ombro direito e coluna lombar',
    ator: 'Consciente, orientado: "Levei um susto grande, mas estou bem, só meu ombro tá dolorido"',
    aparencia: 'Corado, sem palidez ou sudorese',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Consciente e estável no banco do passageiro', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Responder com calma, confirmar que não perdeu a consciência', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Ausente', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Pérvia, voz clara', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '18 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrios vesiculares normais', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '80 bpm, cheio', leitura: '80 bpm', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_perfusao_periferica: { valor: '< 2 segundos', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pressao_arterial: { valor: '125/82 mmHg', leitura: '125/82 mmHg', estado: 'observado', regiao: 'membroSuperiorDireito' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6)', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    sinais_spo2: { valor: '98%', leitura: '98%', estado: 'observado', regiao: 'membroSuperiorDireito' },
    sinais_escala_dor: { valor: '3/10 em ombro direito', leitura: '3/10', estado: 'observado' },
    sec_torax_abdomen_pelve: { valor: 'Marca discreta de cinto de segurança no ombro/tórax, abdômen indolor', estado: 'observado', regiao: 'torax' },
  }),
  cinematica: {
    tipoColisao: 'frontal',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'passageiro',
    retencao: 'comCinto',
    velocidadeImpacto: 30,
    regioesPreviveis: ['torax', 'abdomen'],
  },
  intervencoesCitadas: ['Colar cervical', 'Imobilização em prancha'],
  pendencias: ['Avaliar se a porta do passageiro abre sem necessidade de ferramenta hidráulica'],
  gabaritoInstrutor: {
    triagemSugerida: 'verde',
    justificativaTriagem: 'Fisiologicamente estável, sem aprisionamento complexo.',
    prioridadeExtracao: 'estavel',
    rotasRecomendadas: ['rota_lateral_porta', 'rota_vertical_teto'],
    notasDebriefing: [
      'Permite trabalho em paralelo das equipes, demonstrando boa coordenação de recursos.',
    ],
  },
}

export const VITIMA_1_TCE_CHOQUE: FichaVitimaAtendimento = {
  id: 'vitima1',
  titulo: 'Vítima 1: TCE e Choque em Evolução',
  perfil: {
    papel: 'Ocupante de veículo',
    mecanismo: 'Colisão frontal; impacto em cabeça e abdômen',
    condicaoDescrita: 'TCE com hematoma subdural e suspeita de hemorragia interna abdominal',
    ator: 'Calmo → confuso → sonolento → não responde verbalmente → não responde à dor',
    aparencia: 'Palidez, sudorese fria, sinal de Battle / hematoma retroauricular direito',
    descricao: 'TCE em evolução com aumento da Pressão Intracraniana (PIC) e choque hipovolêmico (hemorragia interna).',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Palidez, sudorese fria; hematoma retroauricular direito', estado: 'observado', regiao: 'cabeca' },
    chegada_instrucao_ator: { valor: 'Começar conversando com queixa de dor de cabeça e ir rebaixando gradativamente', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante externo visível', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea inicialmente pérvia, sem ruídos; indicação imediata de colar cervical', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '20 irpm, regular', leitura: '20 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente bilateralmente sem ruídos adventícios', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '110 bpm, fraco/filiforme', leitura: '110 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: '> 3 segundos', leitura: '> 3 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '110/70 mmHg', leitura: '110/70 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Pálida, fria, pegajosa', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 inicialmente (O4/V5/M6), pupilas anisocóricas', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Anisocóricas (direita maior que esquerda)', estado: 'observado', regiao: 'cabeca' },
    sinais_spo2: { valor: '96% em ar ambiente', leitura: '96%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_glicemia: { valor: '110 mg/dL', estado: 'observado' },
    sinais_temperatura: { valor: '35,8 °C', leitura: '35,8 °C', estado: 'observado', regiao: 'corpoTodo' },
    e_exposicao_dorso: { valor: 'Expor tórax e abdômen; prevenir hipotermia', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: 'Cefaleia 3/10', leitura: '3/10', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Sinal de Battle à direita; traqueia centrada, jugulares planas', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Abdômen distendido e doloroso à palpação profunda; pelve estável', estado: 'observado', regiao: 'abdomen' },
    sample_sintomas: { valor: 'Cefaleia leve e náusea', estado: 'observado' },
    sample_evento_trauma: { valor: 'Colisão frontal forte, bateu a cabeça no para-brisa', estado: 'observado' },
  }),
  /**
   * Timeline didática de deterioração neurológica e choque, em 3 estágios
   * cumulativos além do inicial. Cada estágio só lista o que muda; o resto
   * segue do estágio anterior (ver `estagiosOrdenados` em efeitosClinicos.ts).
   */
  estagios: [
    {
      id: 'compensacao',
      rotulo: 'Compensação',
      achados: {
        c_pulso_radial: { valor: '120 bpm, fraco', leitura: '120 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_pressao_arterial: { valor: '100/65 mmHg (limite inferior, taquicardia compensatória)', leitura: '100/65 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_perfusao_periferica: { valor: '~3 segundos', leitura: '~3 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        d_escala_glasgow: { valor: 'Glasgow 14 (O4/V4/M6), sonolência leve', leitura: 'Glasgow 14', estado: 'observado', regiao: 'cabeca' },
      },
    },
    {
      id: 'deterioracao',
      rotulo: 'Deterioração',
      achados: {
        a_permeabilidade_via_aerea: { valor: 'Roncos de via aérea por queda de língua (obstrução parcial)', estado: 'observado', regiao: 'cabeca' },
        b_frequencia_respiratoria: { valor: '28 irpm, padrão Cheyne-Stokes', leitura: '28 irpm', estado: 'observado', regiao: 'torax' },
        c_pulso_radial: { valor: '130 bpm, filiforme', leitura: '130 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_perfusao_periferica: { valor: '> 5 segundos, cianose de extremidades', leitura: '> 5 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_pressao_arterial: { valor: '90/60 mmHg (choque em aprofundamento)', leitura: '90/60 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        d_escala_glasgow: { valor: 'Glasgow 8 (O2/V2/M4) — perda de consciência aguda', leitura: 'Glasgow 8', estado: 'observado', regiao: 'cabeca' },
        d_nivel_avdi: { valor: 'Responde só à Dor (D)', estado: 'observado', regiao: 'cabeca' },
        sinais_spo2: { valor: '90% em ar ambiente', leitura: '90%', estado: 'observado' },
      },
    },
    {
      id: 'critico',
      rotulo: 'Crítico',
      achados: {
        b_frequencia_respiratoria: { valor: '8 irpm, agônica', leitura: '8 irpm', estado: 'observado', regiao: 'torax' },
        c_pulso_radial: { valor: 'Pulso radial ausente; carotídeo filiforme', leitura: 'ausente', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_pressao_arterial: { valor: '70/40 mmHg (choque refratário)', leitura: '70/40 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        d_escala_glasgow: { valor: 'Glasgow 4 (O1/V1/M2) — postura de descerebração', leitura: 'Glasgow 4', estado: 'observado', regiao: 'cabeca' },
        d_nivel_avdi: { valor: 'Não responde a estímulo doloroso (I)', estado: 'observado', regiao: 'cabeca' },
        sinais_spo2: { valor: '78% em ar ambiente', leitura: '78%', estado: 'observado' },
      },
    },
  ],
  cinematica: {
    tipoColisao: 'frontal',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'motorista',
    retencao: 'semCinto',
    velocidadeImpacto: 60,
    regioesPreviveis: ['cabeca', 'abdomen'],
  },
  intervencoesCitadas: ['Colar cervical', 'Oxigênio alto fluxo', 'Acesso venoso calibroso', 'Manta térmica'],
  pendencias: ['Risco iminente de herniação uncal pelo TCE anisocórico', 'Hemorragia interna abdominal'],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'TCE grave com anisocoria e choque hemorrágico progressivo. Vermelho.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_rapida', 'rota_vertical_teto'],
    notasDebriefing: ['Tempo de cena mínimo necessário: necessidade cirúrgica urgente.'],
  },
}

/**
 * Vítima 9 do roteiro de origem (`vitimas-tabletop.json`): pedestre atropelado
 * com fratura exposta de fêmur direito e sangramento ativo. É o caso-exemplo
 * do motor de efeitos: a regra DIDÁTICA preparada aqui prevê que compressão
 * direta e curativo compressivo não controlam este sangramento e que o
 * torniquete aplicado na perna direita controla. Não é regra universal — o
 * instrutor confere com o protocolo adotado na aula. Itens marcados com "?"
 * na fonte continuam como `incerto`.
 */
export const VITIMA_9_PEDESTRE_HEMORRAGIA: FichaVitimaAtendimento = {
  id: 'vitima9',
  titulo: 'Vítima 9: Pedestre atropelado — hemorragia em coxa direita',
  perfil: {
    papel: 'Pedestre',
    mecanismo: 'Atropelamento por veículo em velocidade',
    condicaoDescrita:
      'Fratura exposta de fêmur direito com sangramento ativo; hipóteses (a confirmar) de lesão torácica esquerda, TCE e fratura pélvica',
    ator: 'Agitado por dor e falta de ar, grita de dor na perna e no peito (10/10); pode ficar confuso e sonolento',
    aparencia: 'Caído na via, deformidade e sangramento visível na coxa direita, pálido e sudoreico',
    descricao: 'Pedestre atropelado por veículo em velocidade. Encontrado na via, politraumatizado.',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: {
      valor: 'Caído na via, grita de dor; sangramento visível na coxa direita, com deformidade',
      estado: 'observado',
      regiao: 'membroInferiorDireito',
    },
    chegada_instrucao_ator: {
      valor: 'Gritar de dor na perna e no peito; responder de forma agitada e confusa',
      estado: 'observado',
    },
    x_hemorragia_externa: {
      valor: 'Sangramento ativo e volumoso na coxa direita, junto a fratura exposta de fêmur',
      estado: 'observado',
      regiao: 'membroInferiorDireito',
    },
    a_permeabilidade_via_aerea: { valor: 'Pérvia enquanto grita', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: {
      valor: '28 irpm, respiração superficial e dolorosa',
      leitura: '28 irpm',
      estado: 'observado',
      regiao: 'torax',
    },
    b_ausculta_pulmonar: { valor: 'Murmúrio possivelmente diminuído à esquerda (a confirmar)', estado: 'incerto', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Possível movimento paradoxal no hemitórax esquerdo (a confirmar)', estado: 'incerto', regiao: 'torax' },
    c_pulso_radial: { valor: '130 bpm, fino e rápido', leitura: '130 bpm', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_perfusao_periferica: { valor: 'Tempo de enchimento capilar > 3 segundos', leitura: '> 3 s', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pressao_arterial: { valor: '100/70 mmHg', leitura: '100/70 mmHg', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pele_temperatura_umidade: { valor: 'Pálida, fria e úmida', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 13 (O4/V3/M6), agitado e confuso', leitura: 'Glasgow 13', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Responde a estímulo verbal/dor', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Expor completamente com cuidado; prevenir hipotermia', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '94% em ar ambiente', leitura: '94%', estado: 'observado', regiao: 'membroSuperiorDireito' },
    sinais_glicemia: { valor: '140 mg/dL', estado: 'observado' },
    sinais_temperatura: { valor: '36,2 °C', leitura: '36,2 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '10/10 na perna e no peito', leitura: '10/10', estado: 'observado' },
    sample_sintomas: { valor: '"Minha perna! Dói muito o peito também..."', estado: 'observado' },
    sample_alergias: { valor: 'Não sabe informar', estado: 'incerto' },
    sample_medicamentos: { valor: 'Não sabe informar', estado: 'incerto' },
    sample_passado_medico: { valor: 'Não sabe informar', estado: 'incerto' },
    sample_liquidos_alimentos: { valor: 'Não sabe informar', estado: 'incerto' },
    sample_evento_trauma: { valor: 'Atropelamento', estado: 'observado' },
    sec_cabeca_pescoco: {
      valor: 'Escoriações e possível hematoma; face estável; traqueia centrada, jugulares planas',
      estado: 'observado',
      regiao: 'cabeca',
    },
    sec_torax_abdomen_pelve: {
      valor:
        'Dor em costelas à esquerda com possível crepitação (a confirmar); abdômen flácido, levemente doloroso; pelve dolorosa e instável à compressão',
      estado: 'incerto',
      regiao: 'torax',
    },
    sec_membros_dorso: {
      valor: 'Perna direita com fratura exposta e deformidade; pulso pedioso fraco; demais membros com escoriações e PMS preservados',
      estado: 'observado',
      regiao: 'membroInferiorDireito',
    },
  }),
  estagios: [
    { id: 'tardio', rotulo: 'Tardio', achados: {
      b_frequencia_respiratoria: { valor: '32 irpm, piora do padrão respiratório', leitura: '32 irpm', estado: 'observado' },
      c_pulso_radial: { valor: '140 bpm, filiforme', leitura: '140 bpm', estado: 'observado' },
      c_perfusao_periferica: { valor: '> 4 segundos', leitura: '> 4 s', estado: 'observado' },
      c_pressao_arterial: { valor: '90/60 mmHg', leitura: '90/60 mmHg', estado: 'observado' },
      c_pele_temperatura_umidade: { valor: 'Mais fria e pegajosa', estado: 'observado' },
      d_escala_glasgow: { valor: 'Glasgow 11 (O3/V2/M6), sonolento', leitura: 'Glasgow 11', estado: 'observado' },
      sinais_spo2: { valor: '90% em ar ambiente', leitura: '90%', estado: 'observado' },
      sinais_temperatura: { valor: '35,8 °C', leitura: '35,8 °C', estado: 'observado' },
    } },
  ],
  problemas: [
    {
      id: 'hemorragia_coxa_direita',
      rotulo: 'Hemorragia em coxa direita',
      regiao: 'membroInferiorDireito',
      visivelNaCena: true,
      critico: true,
      achadosPorEstado: {
        controlado: {
          x_hemorragia_externa: {
            valor: 'Sangramento da coxa direita controlado com torniquete; anotar o horário de aplicação',
            estado: 'observado',
            regiao: 'membroInferiorDireito',
          },
          sec_membros_dorso: {
            valor: 'Perna direita com fratura exposta e deformidade, torniquete aplicado e sangramento controlado; pulso pedioso fraco',
            estado: 'observado',
            regiao: 'membroInferiorDireito',
          },
        },
      },
    },
  ],
  regrasEfeito: [
    {
      id: 'v9-compressao-sem-efeito',
      idProblema: 'hemorragia_coxa_direita',
      tipoIntervencao: 'compressao_direta',
      regioes: ['membroInferiorDireito'],
      resultado: 'sem_efeito',
      explicacao: 'Neste caso preparado, a compressão direta não controla o sangramento da fratura exposta.',
    },
    {
      id: 'v9-curativo-sem-efeito',
      idProblema: 'hemorragia_coxa_direita',
      tipoIntervencao: 'curativo_compressivo',
      regioes: ['membroInferiorDireito'],
      resultado: 'sem_efeito',
      explicacao: 'Neste caso preparado, o curativo compressivo não controla o sangramento da fratura exposta.',
    },
    {
      id: 'v9-torniquete-controla',
      idProblema: 'hemorragia_coxa_direita',
      tipoIntervencao: 'torniquete',
      regioes: ['membroInferiorDireito'],
      resultado: 'controlado',
      explicacao: 'Torniquete aplicado na perna direita controla este sangramento.',
    },
  ],
  referenciaConteudo: {
    fonte: 'Exemplo didático do instrutor (roteiro treinamento-veicular-vitimas, vítima 9) — conferir com o protocolo adotado, ex.: ACS Stop the Bleed',
    versao: '1',
  },
  intervencoesCitadas: [
    'Torniquete na coxa direita',
    'Colar cervical',
    'Prancha',
    'O₂ em alto fluxo',
    'Cinto pélvico (a confirmar)',
    'Manta térmica',
  ],
  pendencias: [
    'Confirmar hipóteses torácica, pélvica e neurológica',
    'Controlar a hemorragia da coxa antes de seguir o XABCDE',
  ],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'Hemorragia exsanguinante em membro com sinais de choque (FC 130, TEC > 3 s). Imediato.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_rapida'],
    notasDebriefing: [
      'O X vem antes do A: controlar a hemorragia exsanguinante é a primeira ação.',
      'Compressão ou curativo sem efeito devem levar à reavaliação e à troca de conduta — não a seguir adiante com o sangramento ativo.',
      'Controlar a hemorragia não normaliza os demais sinais: reavaliar C e manter a vigilância do tórax e da pelve.',
    ],
  },
}

/**
 * Cenário pedido pelo instrutor: colisão frontal entre dois veículos, um
 * motorista em cada um, os dois sem gravidade — para contrastar com os
 * casos críticos já cadastrados. O mesmo evento de cinemática (frontal,
 * outro veículo) serve às duas fichas; o professor pode conduzir as duas
 * vítimas em paralelo ou uma de cada vez.
 */
export const VITIMA_COLISAO_FRONTAL_V1_MOTORISTA: FichaVitimaAtendimento = {
  id: 'colisao_frontal_dois_veiculos_v1',
  titulo: 'Colisão frontal entre dois veículos: Motorista 1 (estável)',
  perfil: {
    papel: 'Motorista',
    mecanismo: 'Colisão frontal moderada entre dois veículos leves; os dois airbags frontais dispararam',
    condicaoDescrita: 'Sem sinais de choque; queixa apenas de dor cervical leve pelo chicote',
    ator: 'Alerta, conversa normalmente; reclama de dor no pescoço e no peito onde o cinto passou',
    aparencia: 'Corado, sem sinais de sofrimento agudo; marca do cinto visível no tórax',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Sentado ao volante, alerta, reclamando de dor cervical leve', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Conversa normalmente, orientado, sem sinais de confusão', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante externo', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea pérvia, fala frases completas', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '18 irpm, regular', leitura: '18 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente bilateralmente, sem ruídos adventícios', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Simétrica, sem sinais de esforço', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '88 bpm, cheio e regular', leitura: '88 bpm', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_perfusao_periferica: { valor: '< 2 segundos', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pressao_arterial: { valor: '120/80 mmHg', leitura: '120/80 mmHg', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pele_temperatura_umidade: { valor: 'Corada, quente e seca', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6)', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas e fotorreagentes', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Sem lesões visíveis no tronco ou no dorso', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '98% em ar ambiente', leitura: '98%', estado: 'observado', regiao: 'membroSuperiorDireito' },
    sinais_temperatura: { valor: '36,5 °C', leitura: '36,5 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '3/10 na região cervical', leitura: '3/10', estado: 'observado' },
    sample_sintomas: { valor: 'Dor cervical leve e desconforto torácico pela marca do cinto', estado: 'observado' },
    sample_evento_trauma: { valor: 'Colisão frontal contra outro veículo, a velocidade moderada', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Sem deformidades; dor à palpação da musculatura cervical, sem dor à palpação óssea', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Marca do cinto no tórax; abdômen indolor e flácido; pelve estável', estado: 'observado', regiao: 'torax' },
    sec_membros_dorso: { valor: 'Sem deformidades; PMS preservado nos 4 membros', estado: 'observado', regiao: 'corpoTodo' },
  }),
  cinematica: {
    tipoColisao: 'frontal',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 40,
    regioesPreviveis: ['torax', 'cabeca'],
  },
  intervencoesCitadas: ['Colar cervical, conforme a queixa', 'Observação e monitorização'],
  pendencias: ['Reavaliar dor cervical/torácica durante o transporte', 'Estabilidade inicial não descarta lesão oculta pelo mecanismo frontal'],
  gabaritoInstrutor: {
    triagemSugerida: 'verde',
    justificativaTriagem: 'Vítima estável, sem sinais de choque ou lesão grave; queixa apenas de dor leve.',
    prioridadeExtracao: 'estavel',
    rotasRecomendadas: ['rota_rapida'],
    notasDebriefing: [
      'Estabilidade inicial não dispensa reavaliação: o mecanismo de colisão frontal ainda impõe risco de lesão oculta.',
      'Colar cervical se indicado pela queixa, mesmo com Glasgow 15 e exame normal.',
    ],
  },
}

export const VITIMA_COLISAO_FRONTAL_V2_MOTORISTA: FichaVitimaAtendimento = {
  id: 'colisao_frontal_dois_veiculos_v2',
  titulo: 'Colisão frontal entre dois veículos: Motorista 2 (estável)',
  perfil: {
    papel: 'Motorista',
    mecanismo: 'Colisão frontal moderada entre dois veículos leves; airbag frontal disparado com estilhaçamento do vidro lateral',
    condicaoDescrita: 'Sem sinais de choque; laceração superficial na testa, já sem sangramento ativo',
    ator: 'Alerta, um pouco ansiosa, orientada; reclama de dor de cabeça leve',
    aparencia: 'Laceração superficial na região frontal, sangramento mínimo já contido',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Sentada ao volante, alerta, com pequeno corte na testa', estado: 'observado', regiao: 'cabeca' },
    chegada_instrucao_ator: { valor: 'Conversa normalmente, ansiosa mas orientada em tempo e espaço', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante externo', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea pérvia, fala frases completas', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '20 irpm, regular', leitura: '20 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente bilateralmente', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Simétrica', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '96 bpm, cheio e regular', leitura: '96 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: '< 2 segundos', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '122/78 mmHg', leitura: '122/78 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Corada, quente e seca', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6)', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas e fotorreagentes', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Sem outras lesões visíveis no tronco ou no dorso', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '98% em ar ambiente', leitura: '98%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '36,6 °C', leitura: '36,6 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '3/10 na testa', leitura: '3/10', estado: 'observado' },
    sample_sintomas: { valor: 'Cefaleia leve e ansiedade; nega tontura ou náusea', estado: 'observado' },
    sample_evento_trauma: { valor: 'Colisão frontal contra outro veículo; a cabeça bateu no vidro lateral já rachado', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Laceração superficial de 2 cm na região frontal, sangramento mínimo já contido; sem dor à palpação óssea', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Marca do cinto no tórax; abdômen indolor; pelve estável', estado: 'observado', regiao: 'torax' },
    sec_membros_dorso: { valor: 'Sem deformidades; PMS preservado nos 4 membros', estado: 'observado', regiao: 'corpoTodo' },
  }),
  cinematica: {
    tipoColisao: 'frontal',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 40,
    regioesPreviveis: ['cabeca'],
  },
  intervencoesCitadas: ['Curativo simples na testa', 'Colar cervical, conforme a queixa', 'Observação e monitorização'],
  pendencias: ['Reavaliar sinais de TCE apesar da laceração parecer superficial', 'Confirmar ausência de fragmento de vidro na ferida'],
  gabaritoInstrutor: {
    triagemSugerida: 'verde',
    justificativaTriagem: 'Vítima estável, Glasgow 15, laceração superficial já contida; sem sinais de choque.',
    prioridadeExtracao: 'estavel',
    rotasRecomendadas: ['rota_rapida'],
    notasDebriefing: [
      'Uma laceração de couro cabeludo ou testa pode sangrar bastante sem ser grave — mas todo TCE, mesmo leve, pede reavaliação neurológica seriada.',
      'Duas vítimas estáveis no mesmo cenário não dispensam avaliação individual completa em cada uma.',
    ],
  },
}

/**
 * Choque lateral com tombamento: o `lateralComCapotamento` do módulo de
 * cinemática já bate especificamente no lado do passageiro (a física do
 * evento é fixa), por isso a vítima fica nesse assento. Hemorragia interna
 * é o ponto didático central — nenhuma intervenção de campo a controla, e
 * as regras abaixo mostram isso explicitamente em vez de deixar "a
 * definir": aqui o "a definir" seria enganoso, porque a resposta é conhecida.
 */
export const VITIMA_LATERAL_CAPOTAMENTO_HEMORRAGIA_INTERNA: FichaVitimaAtendimento = {
  id: 'lateral_capotamento_hemorragia_interna',
  titulo: 'Choque lateral com tombamento: hemorragia interna abdominal',
  perfil: {
    papel: 'Passageiro Dianteiro',
    mecanismo: 'Impacto lateral de outro veículo contra a porta do passageiro, seguido de tombamento com uma volta completa',
    condicaoDescrita: 'Suspeita de hemorragia interna abdominal (provável lesão esplênica); choque hipovolêmico em evolução',
    ator: 'Inicialmente queixosa e ansiosa; evolui para confusão e sonolência conforme o choque se aprofunda',
    aparencia: 'Pálida, sudoreica; sem sangramento externo visível',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Queixa de dor abdominal em cólica no quadrante superior esquerdo, ansiosa', estado: 'observado', regiao: 'abdomen' },
    chegada_instrucao_ator: { valor: 'Responde às perguntas, um pouco agitada pela dor', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante externo', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea pérvia, fala frases completas', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '22 irpm, um pouco taquipneica', leitura: '22 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente bilateralmente', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Simétrica', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '110 bpm, cheio', leitura: '110 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: '~3 segundos', leitura: '~3 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '110/75 mmHg', leitura: '110/75 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Pálida e discretamente sudoreica', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6)', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas e fotorreagentes', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Sem lesões visíveis externamente no dorso', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '96% em ar ambiente', leitura: '96%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '36,2 °C', leitura: '36,2 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '7/10 no abdômen', leitura: '7/10', estado: 'observado' },
    sample_sintomas: { valor: 'Dor abdominal intensa à esquerda, por vezes irradiando para o ombro esquerdo', estado: 'observado' },
    sample_evento_trauma: { valor: 'Impacto lateral de outro veículo seguido de tombamento', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Sem deformidades ou sangramento; traqueia centrada, jugulares planas', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Abdômen distendido e doloroso à palpação no quadrante superior esquerdo, sinal de Kehr positivo (dor referida no ombro); pelve estável', estado: 'observado', regiao: 'abdomen' },
    sec_membros_dorso: { valor: 'Sem deformidades; PMS preservado', estado: 'observado', regiao: 'corpoTodo' },
  }),
  estagios: [
    {
      id: 'descompensacao',
      rotulo: 'Descompensação',
      achados: {
        b_frequencia_respiratoria: { valor: '28 irpm, superficial', leitura: '28 irpm', estado: 'observado', regiao: 'torax' },
        c_pulso_radial: { valor: '128 bpm, fraco e filiforme', leitura: '128 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_perfusao_periferica: { valor: '> 4 segundos', leitura: '> 4 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_pressao_arterial: { valor: '85/60 mmHg', leitura: '85/60 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        d_escala_glasgow: { valor: 'Glasgow 13 (O3/V4/M6), confusa', leitura: 'Glasgow 13', estado: 'observado', regiao: 'cabeca' },
        d_nivel_avdi: { valor: 'Responde a estímulo Verbal (V)', estado: 'observado', regiao: 'cabeca' },
        sinais_spo2: { valor: '90% em ar ambiente', leitura: '90%', estado: 'observado' },
      },
    },
    {
      id: 'critico',
      rotulo: 'Crítico',
      achados: {
        c_pulso_radial: { valor: 'Pulso radial ausente; carotídeo filiforme', leitura: 'ausente', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        c_pressao_arterial: { valor: '60/40 mmHg (choque refratário)', leitura: '60/40 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
        d_escala_glasgow: { valor: 'Glasgow 8 (O2/V2/M4)', leitura: 'Glasgow 8', estado: 'observado', regiao: 'cabeca' },
        d_nivel_avdi: { valor: 'Responde só à Dor (D)', estado: 'observado', regiao: 'cabeca' },
        sinais_spo2: { valor: '85% em ar ambiente', leitura: '85%', estado: 'observado' },
      },
    },
  ],
  problemas: [
    {
      id: 'hemorragia_interna_abdominal',
      rotulo: 'Hemorragia interna abdominal (suspeita de lesão esplênica)',
      regiao: 'abdomen',
      visivelNaCena: false,
      critico: true,
    },
  ],
  regrasEfeito: [
    {
      id: 'lateral-compressao-sem-efeito',
      idProblema: 'hemorragia_interna_abdominal',
      tipoIntervencao: 'compressao_direta',
      regioes: ['abdomen'],
      resultado: 'sem_efeito',
      explicacao: 'Compressão externa não controla hemorragia interna — não há vaso externo a comprimir.',
    },
    {
      id: 'lateral-curativo-sem-efeito',
      idProblema: 'hemorragia_interna_abdominal',
      tipoIntervencao: 'curativo_compressivo',
      regioes: ['abdomen'],
      resultado: 'sem_efeito',
      explicacao: 'Curativo compressivo não tem efeito sobre sangramento intracavitário.',
    },
    {
      id: 'lateral-torniquete-sem-efeito',
      idProblema: 'hemorragia_interna_abdominal',
      tipoIntervencao: 'torniquete',
      regioes: ['abdomen'],
      resultado: 'sem_efeito',
      explicacao: 'Torniquete não se aplica ao tronco e não controla hemorragia interna.',
    },
  ],
  cinematica: {
    tipoColisao: 'lateralComCapotamento',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'passageiro',
    retencao: 'comCinto',
    velocidadeImpacto: 50,
    regioesPreviveis: ['abdomen', 'torax', 'pelve'],
  },
  intervencoesCitadas: ['Colar cervical', 'Oxigenoterapia em alto fluxo', 'Monitorização e transporte rápido', 'Manta térmica'],
  pendencias: ['Hemorragia interna não é controlável no campo — a resolução definitiva é cirúrgica', 'Minimizar o tempo de cena; extração e transporte rápidos'],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'Choque hipovolêmico em evolução por suspeita de hemorragia interna, sem controle possível no campo.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_lateral_porta', 'rota_rapida'],
    notasDebriefing: [
      'Hemorragia interna não responde a compressão, curativo ou torniquete — o tempo de cena é o que salva, não a técnica de campo.',
      'A queda progressiva da PA e do nível de consciência são sinais de choque descompensando; reavaliar com frequência.',
      'O impacto lateral no módulo de cinemática atinge sempre o lado do passageiro — é por isso que a vítima está sentada ali.',
    ],
  },
}

/**
 * Capotamento com o porta-malas contra um muro: a rota de retirada
 * traseira fica fisicamente bloqueada. Isso não é um dado do módulo de
 * cinemática (que só sabe replay de impacto, não obstrução de rota) — é
 * uma decisão de cena que o professor configura no Tabletop (objeto de
 * muro colado na traseira). Aqui isso entra como pendência/nota de
 * debriefing, para o professor lembrar de montar a cena assim.
 */
export const VITIMA_CAPOTAMENTO_V1_GRAVE: FichaVitimaAtendimento = {
  id: 'capotamento_v1_grave_traseiro',
  titulo: 'Capotamento com porta-malas obstruído: Passageiro traseiro (crítico)',
  perfil: {
    papel: 'Passageiro Traseiro',
    mecanismo: 'Capotamento com uma volta completa; veículo parou invertido com o porta-malas contra um muro',
    condicaoDescrita: 'Politrauma por capotamento sem cinto de segurança; suspeita de TCE e fratura pélvica instável',
    ator: 'Grita de dor inicialmente; evolui para respostas confusas e sonolência progressiva',
    aparencia: 'Encontrada próxima ao teto do veículo invertido; hematoma frontal e laceração no couro cabeludo',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Encontrada próxima ao teto do veículo invertido, geme de dor', estado: 'observado', regiao: 'cabeca' },
    chegada_instrucao_ator: { valor: 'Grita de dor inicialmente; respostas confusas às perguntas', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sangramento em lençol por laceração no couro cabeludo, sem jato', estado: 'observado', regiao: 'cabeca' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea pérvia; geme e fala frases curtas', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '26 irpm, superficial', leitura: '26 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente bilateralmente, discretamente diminuído à direita (a confirmar)', estado: 'incerto', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Possível assimetria discreta à direita (a confirmar)', estado: 'incerto', regiao: 'torax' },
    c_pulso_radial: { valor: '124 bpm, fraco', leitura: '124 bpm', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_perfusao_periferica: { valor: '> 4 segundos', leitura: '> 4 s', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pressao_arterial: { valor: '88/58 mmHg', leitura: '88/58 mmHg', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pele_temperatura_umidade: { valor: 'Pálida, fria e sudoreica', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 12 (O3/V4/M5), confusa', leitura: 'Glasgow 12', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Responde a estímulo Verbal (V)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas, discretamente lentificadas', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Hipotermia em evolução; deformidade e dor à palpação da pelve', estado: 'observado', regiao: 'pelve' },
    sinais_spo2: { valor: '92% em ar ambiente', leitura: '92%', estado: 'observado', regiao: 'membroSuperiorDireito' },
    sinais_temperatura: { valor: '35,6 °C', leitura: '35,6 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '9/10 na pelve e na cabeça', leitura: '9/10', estado: 'observado' },
    sample_sintomas: { valor: 'Dor intensa na pelve e cefaleia', estado: 'observado' },
    sample_evento_trauma: { valor: 'Capotamento com uma volta completa; não usava cinto de segurança', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Laceração no couro cabeludo com sangramento em lençol; hematoma frontal', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Pelve dolorosa e instável à compressão lateral; abdômen flácido e indolor', estado: 'observado', regiao: 'pelve' },
    sec_membros_dorso: { valor: 'Sem deformidades evidentes nos membros; PMS preservado', estado: 'observado', regiao: 'corpoTodo' },
  }),
  estagios: [
    {
      id: 'deterioracao',
      rotulo: 'Deterioração',
      achados: {
        d_escala_glasgow: { valor: 'Glasgow 9 (O2/V3/M4)', leitura: 'Glasgow 9', estado: 'observado', regiao: 'cabeca' },
        d_nivel_avdi: { valor: 'Responde à Dor (D)', estado: 'observado', regiao: 'cabeca' },
        c_pulso_radial: { valor: '135 bpm, muito fraco', leitura: '135 bpm', estado: 'observado', regiao: 'membroSuperiorDireito' },
        c_pressao_arterial: { valor: '75/50 mmHg', leitura: '75/50 mmHg', estado: 'observado', regiao: 'membroSuperiorDireito' },
      },
    },
  ],
  problemas: [
    {
      id: 'fratura_pelve_instavel',
      rotulo: 'Fratura pélvica instável',
      regiao: 'pelve',
      visivelNaCena: false,
      critico: true,
    },
    {
      id: 'laceracao_couro_cabeludo',
      rotulo: 'Laceração no couro cabeludo com sangramento em lençol',
      regiao: 'cabeca',
      visivelNaCena: true,
      critico: false,
      achadosPorEstado: {
        controlado: {
          x_hemorragia_externa: { valor: 'Sangramento do couro cabeludo controlado com curativo compressivo', estado: 'observado', regiao: 'cabeca' },
        },
      },
    },
  ],
  regrasEfeito: [
    {
      id: 'capotamento-imobilizacao-pelve-parcial',
      idProblema: 'fratura_pelve_instavel',
      tipoIntervencao: 'imobilizacao_membro',
      regioes: ['pelve'],
      resultado: 'parcial',
      explicacao: 'A imobilização pélvica reduz o volume da cavidade e o sangramento, mas não resolve a instabilidade — resultado parcial.',
    },
    {
      id: 'capotamento-curativo-couro-cabeludo-controla',
      idProblema: 'laceracao_couro_cabeludo',
      tipoIntervencao: 'curativo_compressivo',
      regioes: ['cabeca'],
      resultado: 'controlado',
      explicacao: 'Curativo compressivo controla o sangramento de couro cabeludo.',
    },
  ],
  cinematica: {
    tipoColisao: 'capotamento',
    alvoImpacto: 'muro',
    idAncora: 'traseiroEsquerdo',
    retencao: 'semCinto',
    velocidadeImpacto: 60,
    regioesPreviveis: ['cabeca', 'pelve', 'torax'],
  },
  intervencoesCitadas: ['Colar cervical', 'Curativo compressivo no couro cabeludo', 'Imobilização pélvica improvisada', 'Oxigênio em alto fluxo', 'Manta térmica'],
  pendencias: [
    'Rota traseira (porta-malas) fisicamente bloqueada pelo muro — não é opção de retirada',
    'Confirmar TCE e possível hemorragia interna pélvica',
    'Estabilizar a pelve antes de qualquer movimentação desnecessária',
  ],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'TCE com rebaixamento de consciência e fratura pélvica instável com sinais de choque. Imediato.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_lateral_porta', 'rota_vertical_teto'],
    notasDebriefing: [
      'A rota pelo porta-malas está fisicamente bloqueada pelo muro — nem cogitar essa saída ao planejar.',
      'Fratura pélvica instável: minimizar manipulação e imobilizar antes de mover.',
      'Sem cinto de segurança, o corpo se deslocou livremente durante a rolagem — isso explica o padrão de lesões (cabeça e pelve).',
    ],
  },
}

export const VITIMA_CAPOTAMENTO_V2_ESTAVEL: FichaVitimaAtendimento = {
  id: 'capotamento_v2_estavel_motorista',
  titulo: 'Capotamento com porta-malas obstruído: Motorista (estável)',
  perfil: {
    papel: 'Motorista',
    mecanismo: 'Capotamento com uma volta completa; motorista permaneceu no banco, contida pelo cinto de 3 pontos',
    condicaoDescrita: 'Estável; apenas queixas leves apesar do capotamento, graças à retenção adequada',
    ator: 'Alerta, assustada mas colaborativa, sem sinais de confusão',
    aparencia: 'Presa de cabeça para baixo pelo cinto até a chegada da equipe; sem sangramento visível',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Alerta, presa pelo cinto de segurança, pede ajuda calmamente', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Conversa normalmente, orientada em tempo e espaço', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante externo', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea pérvia, fala frases completas', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '20 irpm, regular', leitura: '20 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente bilateralmente', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Simétrica', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '92 bpm, cheio e regular', leitura: '92 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: '< 2 segundos', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '118/76 mmHg', leitura: '118/76 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Corada, quente e seca', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6)', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas e fotorreagentes', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Sem lesões visíveis; marca do cinto no tórax e no ombro', estado: 'observado', regiao: 'torax' },
    sinais_spo2: { valor: '97% em ar ambiente', leitura: '97%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '36,4 °C', leitura: '36,4 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '2/10, dor leve no ombro pelo cinto', leitura: '2/10', estado: 'observado' },
    sample_sintomas: { valor: 'Dor leve no ombro e no pescoço', estado: 'observado' },
    sample_evento_trauma: { valor: 'Capotamento com uma volta completa; usava cinto de 3 pontos', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Sem deformidades; dor leve à palpação cervical', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Marca do cinto no tórax; abdômen indolor; pelve estável', estado: 'observado', regiao: 'torax' },
    sec_membros_dorso: { valor: 'Sem deformidades; PMS preservado nos 4 membros', estado: 'observado', regiao: 'corpoTodo' },
  }),
  cinematica: {
    tipoColisao: 'capotamento',
    alvoImpacto: 'muro',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 60,
    regioesPreviveis: ['torax', 'cabeca'],
  },
  intervencoesCitadas: ['Colar cervical, como precaução', 'Observação e monitorização'],
  pendencias: [
    'Rota traseira (porta-malas) bloqueada pelo muro — planejar retirada pela porta dianteira ou pelo teto',
    'Reavaliar apesar da estabilidade inicial: o mecanismo de capotamento é significativo',
  ],
  gabaritoInstrutor: {
    triagemSugerida: 'amarelo',
    justificativaTriagem: 'Estável clinicamente, mas o mecanismo de capotamento exige observação — não subestimar apesar da ausência de sinais de choque.',
    prioridadeExtracao: 'urgente',
    rotasRecomendadas: ['rota_lateral_porta'],
    notasDebriefing: [
      'Estabilidade clínica não elimina o risco: o mecanismo de capotamento por si só justifica reavaliação constante.',
      'A rota planejada não pode ser pelo porta-malas: está bloqueada pelo muro nesta cena.',
      'Duas vítimas do mesmo capotamento podem ter desfechos completamente diferentes — o cinto de segurança foi o fator decisivo aqui.',
    ],
  },
}

export const VITIMA_CAPOTAMENTO_EJETADA: FichaVitimaAtendimento = {
  id: 'capotamento_ejetada_solo',
  titulo: 'Capotamento: V1 — Ejetada no Solo (Crítica / TCE Grave)',
  perfil: {
    papel: 'Passageiro Dianteiro',
    mecanismo: 'Capotamento com múltiplas voltas; ejetada pelo pára-brisa/janela por não usar cinto; arremessada no asfalto a 4 m do veículo',
    condicaoDescrita: 'Politrauma severo por ejeção: TCE grave com rebaixamento (Glasgow 7), vias aéreas com roncos e choque hipovolêmico/neurogênico',
    ator: 'Inconsciente; geme à dor profunda, flexão anormal de membros superiores (decorticação), não responde verbalmente',
    aparencia: 'Caída em decúbito dorsal na pista fria, palidez intensa, escoriações extensas no tórax e membros, sangramento ativo em couro cabeludo',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Caída imóvel a 4 metros do veículo capotado; escoriações extensas e sangramento craniano visível', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Inconsciente, sons inarticulados à dor profunda', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sangramento ativo contínuo em couro cabeludo por laceração frontal extensa; sem jato arterial visível', estado: 'observado', regiao: 'cabeca' },
    a_permeabilidade_via_aerea: { valor: 'Vias aéreas parcialmente obstruídas por queda de língua e sangue; roncos inspiratórios audíveis; melhora após manobra de tração da mandíbula (jaw thrust)', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '28 irpm, padrão rápido, superficial e irregular', leitura: '28 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente bilateralmente, discretamente diminuído em bases', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Simétrica, escoriações por atrito na parede torácica anterior', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '136 bpm, filiforme e muito fraco; pulso carotídeo palpável', leitura: '136 bpm', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_perfusao_periferica: { valor: '> 4 segundos; extremidades pálidas e frias', leitura: '> 4 s', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pressao_arterial: { valor: '82/50 mmHg (hipotensão severa / choque)', leitura: '82/50 mmHg', estado: 'observado', regiao: 'membroSuperiorDireito' },
    c_pele_temperatura_umidade: { valor: 'Muito fria, pálida e sudoreica', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 7 (O1 / V2 / M4) — Coma / TCE grave com rigidez de decorticação', leitura: 'Glasgow 7', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Responde apenas à Dor profunda (D)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Anisocóricas (direita 5 mm midriática, esquerda 3 mm), lentificadas à luz', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Temperatura 35,0 °C (hipotermia severa); escoriações no dorso ao rolamento em bloco de 90°', estado: 'observado', regiao: 'dorso' },
    sinais_spo2: { valor: '88% em ar ambiente; sobe para 95% com O2 suplementar sob máscara 15 L/min', leitura: '88%', estado: 'observado', regiao: 'membroSuperiorDireito' },
    sinais_temperatura: { valor: '35,0 °C', leitura: '35,0 °C', estado: 'observado', regiao: 'corpoTodo' },
    sample_sintomas: { valor: 'Incapaz de relatar sintomas (inconsciente)', estado: 'observado' },
    sample_evento_trauma: { valor: 'Ejetada durante capotamento em alta velocidade; sem cinto de segurança', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Laceração de couro cabeludo frontal direita de 8 cm; hematoma periorbital em evolução; dor/crepitação craniana', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Escoriações torácicas; abdômen rígido à palpação profunda; pelve instável à compressão lateral', estado: 'observado', regiao: 'pelve' },
    sec_membros_dorso: { valor: 'Múltiplas escoriações e fratura fechada em antebraço esquerdo; PMS diminuído em extremidades frias', estado: 'observado', regiao: 'corpoTodo' },
  }),
  cinematica: {
    tipoColisao: 'capotamento',
    alvoImpacto: 'muro',
    idAncora: 'passageiro',
    retencao: 'semCinto',
    velocidadeImpacto: 80,
    regioesPreviveis: ['cabeca', 'pelve', 'torax', 'corpoTodo'],
  },
  intervencoesCitadas: [
    'Manobra de tração de mandíbula (jaw thrust) e cânula orofaríngea (Guedel)',
    'Oxigenioterapia de alto fluxo (15 L/min)',
    'Colar cervical e imobilização em prancha longa com rolamento em bloco 90°',
    'Curativo compressivo no couro cabeludo',
    'Estabilização de pelve com cinta pélvica',
    'Manta térmica imediata para prevenir tríade letal',
  ],
  pendencias: [
    'Via aérea crítica: risco iminente de perda de reflexos de proteção',
    'Ejeção veicular multiplica risco de lesão espinhal e hemorragia oculta',
  ],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'Glasgow 7 (TCE grave), via aérea comprometida (roncos/SpO2 88%), hipotensão (PA 82/50) e pupilas anisocóricas. Prioridade Vermelho Imediato.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_rapida'],
    notasDebriefing: [
      'Mesmo estando já fora do veículo, esta vítima é a prioridade máxima da ocorrência devido ao risco iminente de óbito.',
      'O socorrista de APH deve iniciar imediatamente o manejo de via aérea e controle cervical na pista antes de remover a vítima para local seguro.',
      'A ejeção ocorreu pela ausência de cinto de segurança durante as voltas de capotamento.',
    ],
  },
}

export const VITIMA_CAPOTAMENTO_VEICULO: FichaVitimaAtendimento = {
  id: 'capotamento_ocupante_veiculo',
  titulo: 'Capotamento: V2 — Ocupante no Veículo Invertido (Estável / Retida)',
  perfil: {
    papel: 'Condutora (Interior)',
    mecanismo: 'Permaneceu contida pelo cinto de 3 pontos durante todas as voltas de capotamento; veículo parou invertido sobre o teto',
    condicaoDescrita: 'Estável hemodinamicamente; presa de cabeça para baixo pelo cinto; assustada e com dores leves em coluna cervical e clavícula',
    ator: 'Lúcida, orientada, assustada; pede ajuda para ser solta do cinto ("Por favor me tirem daqui, minha cabeça está doendo de ficar de ponta-cabeça")',
    aparencia: 'Suspensa de cabeça para baixo pelo cinto de segurança; cabeça a cerca de 10 cm do teto colapsado; sem sangramentos graves visíveis',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Suspensa pelo cinto no veículo invertido; lúcida e colaborativa; pede socorro', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Conversa orientada em tempo e espaço, queixa-se de tontura pela posição invertida', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento exsanguinante visível', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Vias aéreas pérvias, fala normalmente em frases completas', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '20 irpm, padrão regular e eupneico', leitura: '20 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrio vesicular presente e simétrico bilateralmente', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Simétrica, sem assimetrias ou dor ventilatória', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '90 bpm, cheio, forte e regular', leitura: '90 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: '< 2 segundos; extremidades aquecidas', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '124/82 mmHg (estável)', leitura: '124/82 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Corada, quente e seca', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4 / V5 / M6) — Estado neurológico preservado', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta (A)', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas e fotorreativas', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Temperatura 36,4 °C; sem deformidades ósseas visíveis', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '98% em ar ambiente', leitura: '98%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '36,4 °C', leitura: '36,4 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '3/10 (dor muscular em ombro esquerdo e pescoço)', leitura: '3/10', estado: 'observado' },
    sample_sintomas: { valor: 'Tontura leve pela posição invertida e desconforto na clavícula esquerda', estado: 'observado' },
    sample_evento_trauma: { valor: 'Condutora, usava cinto de 3 pontos durante capotamento', estado: 'observado' },
    sec_cabeca_pescoco: { valor: 'Crânio íntegro; dor leve à palpação de trapézio; sem desvio traqueal', estado: 'observado', regiao: 'cabeca' },
    sec_torax_abdomen_pelve: { valor: 'Marca avermelhada do cinto sobre ombro esquerdo e tórax; abdômen flácido e indolor; pelve estável', estado: 'observado', regiao: 'torax' },
    sec_membros_dorso: { valor: 'Membros íntegros, PMS totalmente preservado nos 4 membros', estado: 'observado', regiao: 'corpoTodo' },
  }),
  cinematica: {
    tipoColisao: 'capotamento',
    alvoImpacto: 'muro',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 80,
    regioesPreviveis: ['cabeca', 'torax', 'corpoTodo'],
  },
  intervencoesCitadas: [
    'Estabilização manual da cervical e colocação de colar cervical antes da liberação',
    'Amparo do tronco e cabeça por socorrista interno ao cortar/soltar o cinto (evitar queda livre contra o teto)',
    'Retirada controlada em prancha longa pela tampa traseira (porta-malas) ou abertura lateral',
  ],
  pendencias: [
    'A liberação do cinto com o veículo invertido sem apoio pode causar queda brusca da vítima sobre a própria cabeça/pescoço',
    'Veículo capotado exige calçamento primário rigoroso antes do socorrista adentrar',
  ],
  gabaritoInstrutor: {
    triagemSugerida: 'amarelo',
    justificativaTriagem: 'Estável clinicamente (Glasgow 15, sem choque, SpO2 98%), mas requer extração técnica assistida pela guarnição de salvamento veicular. Triagem Amarelo.',
    prioridadeExtracao: 'urgente',
    rotasRecomendadas: ['rota_longitudinal_traseira', 'rota_lateral_porta'],
    notasDebriefing: [
      'O uso do cinto de segurança salvou a vida desta condutora, mantendo-a no habitáculo enquanto a outra vítima não retida foi arremessada.',
      'Procedimento crítico no capotamento: o socorrista interno DEVE apoiar o corpo da vítima antes de desatar o cinto para evitar lesão cervical secundária por queda.',
    ],
  },
}

export const VITIMA_SOBRE_OUTRO_V1_INFERIOR: FichaVitimaAtendimento = {
  id: 'sobre_outro_v1_inferior',
  titulo: 'Cenário 4: V1 Condutor no Veículo Inferior (Sob a Carga)',
  perfil: {
    papel: 'Condutor — Veículo Inferior',
    mecanismo: 'Compressão estática e dinâmica de teto por sobreposição de outro veículo',
    condicaoDescrita: 'Encarceramento mecânico tipo II sob peso elevado, dor torácica aguda e taquipneia',
    ator: 'Geme de dor com a pressão do teto rebaixado: "Tem um carro em cima de mim... tá pesando muito, me tira daqui..."',
    aparencia: 'Sudorese fria, pálido, taquipneico, sem sangramento pulsátil visível',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Pálido e ansioso, queixando-se de esmagamento no tórax superior', estado: 'observado', regiao: 'torax' },
    chegada_instrucao_ator: { valor: 'Expressar urgência e desconforto torácico, cooperativo mas com respiração curta', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento massivo externo em grandes artérias', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Vias aéreas pérvias com controle cervical manual obrigatório', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '26 irpm, respiração torácica restritiva superficial', leitura: '26 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrios presentes bilateralmente, sem ruídos adventícios graves imediatos', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Reduzida pela deformação mecânica do teto e volante', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '116 bpm, rítmico, fino mas palpável', leitura: '116 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: 'Enchimento capilar de 2,5 segundos', leitura: '2,5 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '100/65 mmHg', leitura: '100/65 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Fria e úmida', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 14 (O4/V4/M6), confuso quanto ao tempo exato do impacto', leitura: 'Glasgow 14', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta / Verbal', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Pupilas isocóricas e fotorreagentes', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Retenção física de pernas sob o painel e teto colapsado a 15 cm da cabeça', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '93% em ar ambiente', leitura: '93%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '35,8 °C', leitura: '35,8 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '8/10 em tórax anterior e ombros', leitura: '8/10', estado: 'observado' },
    sample_sintomas: { valor: '"O peso no teto tá esmagando meu peito, dói pra respirar fundo"', estado: 'observado' },
    sample_evento_trauma: { valor: 'Veículo atingido em cruzamento com subida e tombamento do outro carro sobre seu teto', estado: 'observado' },
  }),
  cinematica: {
    tipoColisao: 'tombamento',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 50,
    regioesPreviveis: ['cabeca', 'torax', 'membroInferiorEsquerdo', 'membroInferiorDireito'],
  },
  intervencoesCitadas: ['Estabilização primária com V-Strut e Fita Catraca antes de adentrar', 'Alívio de teto', 'Colar cervical', 'Oxigenoterapia'],
  pendencias: ['Risco iminente de colapso estrutural da carga suspensa se o veículo for movimentado'],
  gabaritoInstrutor: {
    triagemSugerida: 'vermelho',
    justificativaTriagem: 'Encarceramento mecânico crítico com comprometimento ventilatório restritivo e choque iminente. Triagem Vermelho com prioridade absoluta de estabilização estrutural.',
    prioridadeExtracao: 'imediata',
    rotasRecomendadas: ['rota_lateral_porta', 'rota_rapida'],
    notasDebriefing: [
      'DOUTRINA DE ESTABILIZAÇÃO: É expressamente proibido iniciar cortes ou adentrar o veículo inferior antes de travar o carro superior com V-Struts fincados no solo e amarrar os dois veículos com fita catraca em bloco único.',
      'Qualquer movimentação no carro inferior pode desestabilizar o superior e provocar esmagamento catastrófico.',
    ],
  },
}

export const VITIMA_SOBRE_OUTRO_V2_SUPERIOR: FichaVitimaAtendimento = {
  id: 'sobre_outro_v2_superior',
  titulo: 'Cenário 4: V2 Ocupante no Veículo Superior (Encavalado)',
  perfil: {
    papel: 'Condutor — Veículo Superior',
    mecanismo: 'Veículo empoleirado e tombado em ângulo agudo a 1,4 m de altura',
    condicaoDescrita: 'Estável clinicamente, sem encarceramento mecânico mas impossibilitado de sair por desnível e risco de queda',
    ator: 'Consciente e apavorado com a altura e inclinação: "Não balança o carro! Se mexer isso vai cair lá embaixo!"',
    aparencia: 'Corado, orientado, sem dispneia ou sangramento, segurando-se no volante e na porta',
  },
  achadosIniciais: preencherAchados({
    chegada_queixa_aparencia: { valor: 'Orientado, assustado com a inclinação e altura do veículo', estado: 'observado', regiao: 'corpoTodo' },
    chegada_instrucao_ator: { valor: 'Gritar para não balançarem o carro; recusar-se a pular até que esteja seguro', estado: 'observado' },
    x_hemorragia_externa: { valor: 'Sem sangramento ativo', estado: 'negativo', regiao: 'corpoTodo' },
    a_permeabilidade_via_aerea: { valor: 'Via aérea pérvia, fala normalmente', estado: 'observado', regiao: 'cabeca' },
    b_frequencia_respiratoria: { valor: '18 irpm, padrão rítmico e regular', leitura: '18 irpm', estado: 'observado', regiao: 'torax' },
    b_ausculta_pulmonar: { valor: 'Murmúrios vesiculares universais e simétricos', estado: 'observado', regiao: 'torax' },
    b_expansao_toracica: { valor: 'Normal', estado: 'observado', regiao: 'torax' },
    c_pulso_radial: { valor: '86 bpm, cheio e regular', leitura: '86 bpm', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_perfusao_periferica: { valor: 'Enchimento capilar < 2 segundos', leitura: '< 2 s', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pressao_arterial: { valor: '125/80 mmHg', leitura: '125/80 mmHg', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    c_pele_temperatura_umidade: { valor: 'Quente e seca', estado: 'observado', regiao: 'corpoTodo' },
    d_escala_glasgow: { valor: 'Glasgow 15 (O4/V5/M6), lúcido e orientado', leitura: 'Glasgow 15', estado: 'observado', regiao: 'cabeca' },
    d_nivel_avdi: { valor: 'Alerta', estado: 'observado', regiao: 'cabeca' },
    d_pupilas: { valor: 'Isocóricas e fotorreagentes', estado: 'observado', regiao: 'cabeca' },
    e_exposicao_dorso: { valor: 'Sem fraturas aparentes, suspensa pelo assento e portas fechadas', estado: 'observado', regiao: 'corpoTodo' },
    sinais_spo2: { valor: '98% em ar ambiente', leitura: '98%', estado: 'observado', regiao: 'membroSuperiorEsquerdo' },
    sinais_temperatura: { valor: '36,5 °C', leitura: '36,5 °C', estado: 'observado', regiao: 'corpoTodo' },
    sinais_escala_dor: { valor: '2/10 leve desconforto cervical por tensão muscular', leitura: '2/10', estado: 'observado' },
    sample_sintomas: { valor: '"Tô bem, só com medo de despencar desse carro"', estado: 'observado' },
  }),
  cinematica: {
    tipoColisao: 'tombamento',
    alvoImpacto: 'outroVeiculo',
    idAncora: 'motorista',
    retencao: 'comCinto',
    velocidadeImpacto: 45,
    regioesPreviveis: ['cabeca', 'torax'],
  },
  intervencoesCitadas: ['Orientação verbal de calma', 'Aguardar monobloco com catracas', 'Retirada assistida em plano elevado'],
  pendencias: ['Aguardar escoramento completo antes da retirada para não alterar o centro de massa'],
  gabaritoInstrutor: {
    triagemSugerida: 'amarelo',
    justificativaTriagem: 'Estável clinicamente (Glasgow 15, hemodinâmica normal), sem risco de morte iminente, porém impossibilitada de sair sem apoio da guarnição. Triagem Amarelo.',
    prioridadeExtracao: 'urgente',
    rotasRecomendadas: ['autoextracao_assistida', 'rota_vertical_teto'],
    notasDebriefing: [
      'A retirada do ocupante superior só ocorre após a consolidação dos V-Struts e catracas, ou paralelamente se houver rota estável que não desloque a carga sobre a vítima inferior.',
    ],
  },
}

export const VITIMAS_CADAS_TRADAS: readonly FichaVitimaAtendimento[] = [
  VITIMA_SLIDE_49_V1_MOTORISTA,
  VITIMA_SLIDE_51_V1_MOTORISTA,
  VITIMA_SLIDE_51_V2_PASSAGEIRO,
  VITIMA_SLIDE_53_V1_MOTORISTA,
  VITIMA_SLIDE_53_V2_PASSAGEIRO,
  VITIMA_1_TCE_CHOQUE,
  ...VITIMAS_TREINAMENTO,
  VITIMA_9_PEDESTRE_HEMORRAGIA,
  VITIMA_COLISAO_FRONTAL_V1_MOTORISTA,
  VITIMA_COLISAO_FRONTAL_V2_MOTORISTA,
  VITIMA_LATERAL_CAPOTAMENTO_HEMORRAGIA_INTERNA,
  VITIMA_CAPOTAMENTO_V1_GRAVE,
  VITIMA_CAPOTAMENTO_V2_ESTAVEL,
  VITIMA_CAPOTAMENTO_EJETADA,
  VITIMA_CAPOTAMENTO_VEICULO,
  VITIMA_SOBRE_OUTRO_V1_INFERIOR,
  VITIMA_SOBRE_OUTRO_V2_SUPERIOR,
]

export const VITIMAS_POR_ID: Readonly<Record<string, FichaVitimaAtendimento>> = Object.fromEntries(
  VITIMAS_CADAS_TRADAS.map((v) => [v.id, v]),
)

